<div class="container panel">
  <mat-nav-list class="remove-padding custom-selection">
    <ng-container  *ngFor="let option of options let lastItem = last; trackBy: trackItem">
      <mat-list-item (click)="setSelectedValue(option.data)">
        <div class="option-wrapper">
          @if (option.icon) {
            <div class="option-icon"><mat-icon>{{ option.icon }}</mat-icon></div>
          }
          <div class="option-text">{{ option.name }}</div>
          @if (option.data === selectedValue) {
            <div class="option-icon"><mat-icon >check</mat-icon></div>
          }
        </div>
      </mat-list-item>
      <mat-divider class="divider-class" *ngIf="!lastItem"></mat-divider>
    </ng-container>
  </mat-nav-list>
</div>
